import { useContext } from "react";
import Button from "@/shared-components/Button/Button";
import { ComponentsContext, IComponentsContext } from "@/contexts";
import { ToggleElementProps } from "@/shared-components";
import { MuxRegPlus } from "@/Icons";
import { FILTERS_ADD_NEW_BUTTON_TESTID } from "@/constants/test-ids";
import styles from "./AddNewListItem.module.scss";

export interface AddMenuItem {
  text: string;
  icon?: React.ReactNode;
  onClick: () => void;
}

interface AddNewItemProps {
  isActive: boolean;
  handleAddItem?: () => void;
  menuItems?: AddMenuItem[];
}

export const AddNewItem = ({
  isActive,
  handleAddItem = () => {},
  menuItems,
}: AddNewItemProps) => {
  const { DropdownMenu, DropdownMenuBody, DropdownMenuItem } =
    useContext<IComponentsContext>(ComponentsContext);

  if (!isActive) {
    return null;
  }

  const button = (onClick: () => void) => (
    <Button
      data-product_tour_id="add-new-filter-folder"
      className={styles.ptTreeAddNewListItem}
      data-testid={FILTERS_ADD_NEW_BUTTON_TESTID}
      icon={<MuxRegPlus />}
      onClick={onClick}
      size="large"
      type="secondary"
    />
  );

  if (!menuItems?.length) {
    return button(handleAddItem);
  }

  return (
    <DropdownMenu
      overlayProps={{ placement: "bottom-end", flip: true }}
      toggleElement={({ toggle }: ToggleElementProps) => button(toggle)}
    >
      <DropdownMenuBody>
        {menuItems.map((item) => (
          <DropdownMenuItem
            key={item.text}
            icon={item.icon}
            text={item.text}
            onClick={item.onClick}
          />
        ))}
      </DropdownMenuBody>
    </DropdownMenu>
  );
};
